import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PortalComponent } from './portal.component';
import { PortalResolve } from './portal.resolve';
import { ProfileComponent } from './profile/profile.component';
import { EditAddressComponent } from './profile/captain/address/edit/edit-address.component';
import { EditProfilePhotoComponent } from './profile/profile-photo/edit/edit-profile-photo.component';
import { EditDescriptionComponent } from './profile/captain/description/edit/edit-description.component';
import { EditAvailabilityComponent } from './profile/captain/availability/edit/edit-availability.component';
import { AdminComponent } from './admin/admin.component';
import { BookingsResolve } from './admin/bookings/bookings.resolve';
import { EditBookingComponent } from './admin/bookings/edit/edit-booking.component';
import { BookingsComponent } from './admin/bookings/bookings.component';
import { EditCaptainsComponent } from './admin/captains/edit/edit-captains.component';
import { EditCaptainsResolve } from './admin/captains/edit/edit-captains.resolve';
import { CaptainsComponent } from './admin/captains/captains.component';
import { CaptainsResolve } from './admin/captains/captains.resolve';
import { CouponFormComponent } from './admin/coupons/form/coupon-form.component';
import { CouponFormResolve } from './admin/coupons/form/coupon-form.resolve';
import { CouponsResolve } from './admin/coupons/coupons.resolve';
import { CouponsComponent } from './admin/coupons/coupons.component';
import { RoleResolve } from './admin/roles/role.resolve';
import { AddRoleComponent } from './admin/roles/add/add-role.component';
import { EditRoleComponent } from './admin/roles/edit/edit-role.component';
import { RoleComponent } from './admin/roles/role.component';
import { AddUserComponent } from './admin/users/add/add-user.component';
import { UserResolve } from './admin/users/user.resolve';
import { EditUserComponent } from './admin/users/edit/edit-user.component';
import { UserComponent } from './admin/users/user.component';
import { WaterBodiesFormComponent } from './admin/water-bodies/form/water-bodies-form.component';
import { WaterBodiesFormResolve } from './admin/water-bodies/form/water-bodies-form.resolve';
import { WaterBodiesResolve } from './admin/water-bodies/water-bodies.resolve';
import { WaterBodiesComponent } from './admin/water-bodies/water-bodies.component';
import { BoatyardComponent } from './profile/captain/boatyard/boatyard.component';
import { BoatyardResolve } from './profile/captain/boatyard/boatyard.resolve';
import { VesselEditComponent } from './profile/captain/boatyard/vessel-edit/vessel-edit.component';
import { VesselEditResolve } from './profile/captain/boatyard/vessel-edit/vessel-edit.resolve';
import { SelectServiceComponent } from '../sign-up/become-a-captain/select-service/select-service.component';
import { SelectServiceResolve } from '../sign-up/become-a-captain/select-service/select-service.resolve';
import { VesselsComponent } from './admin/vessels/vessels.component';
import { ReportsComponent } from './admin/reports/reports.component';
import { ReportsResolve } from './admin/reports/reports.resolve';
import { ChartersGridComponent } from './charters/charters-grid/charters-grid.component';
import { ChartersGridResolve } from './charters/charters-grid/charters-grid.resolve';
import { AddCharterComponent } from './charters/add/add.component';
import { AddCharterResolve } from './charters/add/add.resolve';
import { EditCharterComponent } from './charters/edit/edit.component';
import { EditCharterResolve } from './charters/edit/edit.resolve';
import { ManageCharterResolve } from './charters/manage-charter/manage-charter.resolve';
import { ManageCharterComponent } from './charters/manage-charter/manage-charter.component';
import { UnpaidChartersComponent } from './charters/unpaid-charters/unpaid-charters.component';
import { UnpaidChartersResolve } from './charters/unpaid-charters/unpaid-charters.resolve';
import { EditUserResolve } from './admin/users/edit/edit-user.resolve';
import { BrokerComponent } from './broker/broker.component';
import { BoatOwnerComponent } from './admin/boat-owners/boat-owner.component';
import { BoatOwnerResolve } from './admin/boat-owners/boat-owner.resolve';
import { UnverifiedCustomersComponent } from './admin/customers/unverified-customers/unverified-customers.component';
import { AddWaterBodiesComponent } from './admin/water-bodies/add/add-water-bodies.component';
import { AffiliateDashboardComponent } from '../affiliate/affiliate-dashboard/affiliate-dashboard.component';
import { CharterCaptainsComponent } from './profile/captain/charter-captains/charter-captains.component';
import { AssignCaptainsComponent } from './profile/captain/charter-captains/assign-captains/assign-captains.component';
import { AffiliateGridComponent } from './admin/affiliate-grid/affiliate-grid.component';
import { BankInformationComponent } from './profile/bank-information/bank-information.component';
import { PostsComponent } from './posts/posts.component';
import { AddEditPostsComponent } from './posts/add-edit-posts/add-edit-posts.component';
import { CaptainDeletionRequestComponent } from '../captain/captain-deletion-request/captain-deletion-request.component';
import { ProfileResolve } from './profile/profile.resolve';
import { BookingsManagerComponent } from './bookings-manager/bookings-manager.component';
import { BookingsManagerResolve } from './bookings-manager/bookings-manager.resolve';
import { AuthGuard } from '../../core/services/authGuard';
import { RoleGuard } from '../../core/services/roleGuard';
import { MessagingResolve } from './messaging-dashboard/messaging-dashboard.resolve';
import { MessagingDashboardComponent } from './messaging-dashboard/messaging-dashboard.component';
import { BookingDetailsWrapperComponent } from './bookings-manager/booking-details-wrapper/booking-details-wrapper.component';
import { BookingDetailsWrapperResolve } from './bookings-manager/booking-details-wrapper/booking-details-wrapper.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: PortalComponent,
        resolve: {
          portal: PortalResolve,
        },
        canActivate: [AuthGuard],
        children: [
          {
            path: 'messages',
            component: MessagingDashboardComponent,
            resolve: {
              session: MessagingResolve,
            },
          },
          {
            path: 'admin/boat-owners',
            component: BoatOwnerComponent,
            resolve: {
              portal: BoatOwnerResolve,
            },
            canActivate: [RoleGuard],
            data: { roles: ['Admin'] },
          },
          {
            path: '',
            component: ProfileComponent,
            resolve: {
              profileResolve: ProfileResolve,
            },
          },
          {
            path: 'charters',
            component: ChartersGridComponent,
            resolve: {
              charters: ChartersGridResolve,
            },
          },
          {
            path: 'charters/status/:status',
            component: ChartersGridComponent,
            resolve: {
              charters: ChartersGridResolve,
            },
          },
          {
            path: 'charters/add',
            component: AddCharterComponent,
            resolve: {
              charters: AddCharterResolve,
            },
          },
          {
            path: 'charters/:id/edit',
            component: EditCharterComponent,
            resolve: {
              charter: EditCharterResolve,
            },
          },
          {
            path: 'manage-charter/:id',
            component: ManageCharterComponent,
            resolve: {
              charter: ManageCharterResolve,
            },
          },
          {
            path: 'unpaid-charters',
            component: UnpaidChartersComponent,
            resolve: {
              payouts: UnpaidChartersResolve,
            },
          },
          {
            path: 'profile-photo',
            component: EditProfilePhotoComponent,
          },
          {
            path: 'captain-address',
            component: EditAddressComponent,
          },
          {
            path: 'charter-captains',
            component: CharterCaptainsComponent,
          },
          {
            path: 'assign-captain/:charterId',
            component: AssignCaptainsComponent,
          },
          {
            path: 'affiliate-dashboard',
            component: AffiliateDashboardComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'captain-description',
            component: EditDescriptionComponent,
          },
          {
            path: 'captain-availability',
            component: EditAvailabilityComponent,
          },
          {
            path: 'broker-dashboard',
            component: BrokerComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'bookings-manager',
            component: BookingsManagerComponent,
            resolve: {
              session: BookingsManagerResolve,
            },
          },
          {
            path: 'bookings-manager/:charterId',
            component: BookingDetailsWrapperComponent,
            resolve: {
              session: BookingDetailsWrapperResolve,
            },
          },
          {
            path: 'admin',
            component: AdminComponent,
            canActivate: [RoleGuard],
            data: { roles: ['Admin'] },
          },
          {
            path: 'admin/bookings/edit/:id',
            component: EditBookingComponent,
            canActivate: [RoleGuard],
            data: { roles: ['Admin'] },
            resolve: {
              bookings: BookingsResolve,
            },
          },
          {
            path: 'admin/bookings',
            component: BookingsComponent,
            canActivate: [RoleGuard],
            data: { roles: ['Admin'] },
            resolve: {
              portal: BookingsResolve,
            },
          },
          {
            path: 'admin/captain/edit/:id',
            component: EditCaptainsComponent,
            canActivate: [RoleGuard],
            data: { roles: ['Admin'] },
            resolve: {
              captains: EditCaptainsResolve,
            },
          },
          {
            path: 'admin/captains',
            component: CaptainsComponent,
            canActivate: [RoleGuard],
            data: { roles: ['Admin'] },
            resolve: {
              captains: CaptainsResolve,
            },
          },
          {
            path: 'admin/vessels',
            component: VesselsComponent,
            canActivate: [RoleGuard],
            data: { roles: ['Admin'] },
            resolve: {
              // portal: VesselsResolve,
            },
          },
          {
            path: 'admin/coupons/edit/:id',
            component: CouponFormComponent,
            canActivate: [RoleGuard],
            data: { roles: ['Admin'] },
            resolve: {
              coupons: CouponFormResolve,
            },
          },
          {
            path: 'admin/coupons/add',
            component: CouponFormComponent,
            canActivate: [RoleGuard],
            data: { roles: ['Admin'] },
            resolve: {
              coupons: CouponFormResolve,
            },
          },
          {
            path: 'admin/coupons',
            component: CouponsComponent,
            canActivate: [RoleGuard],
            data: { roles: ['Admin'] },
            resolve: {
              portal: CouponsResolve,
            },
          },
          {
            path: 'admin/roles/add',
            component: AddRoleComponent,
            canActivate: [RoleGuard],
            data: { roles: ['Admin'] },
            resolve: {
              roles: RoleResolve,
            },
          },
          {
            path: 'admin/role/edit/:id',
            component: EditRoleComponent,
            canActivate: [RoleGuard],
            data: { roles: ['Admin'] },
            resolve: {
              roles: RoleResolve,
            },
          },
          {
            path: 'admin/roles',
            component: RoleComponent,
            canActivate: [RoleGuard],
            data: { roles: ['Admin'] },
            resolve: {
              roles: RoleResolve,
            },
          },
          {
            path: 'admin/unverified-customers',
            component: UnverifiedCustomersComponent,
            canActivate: [RoleGuard, AuthGuard],
            data: { roles: ['Admin'] },
          },
          {
            path: 'admin/affiliate-grid',
            component: AffiliateGridComponent,
            canActivate: [RoleGuard, AuthGuard],
            data: { roles: ['Admin'] },
          },
          {
            path: 'admin/users/add',
            component: AddUserComponent,
            canActivate: [RoleGuard, AuthGuard],
            data: { roles: ['Admin'] },
            resolve: {
              users: UserResolve,
            },
          },
          {
            path: 'admin/user/edit/:id',
            component: EditUserComponent,
            canActivate: [RoleGuard, AuthGuard],
            data: { roles: ['Admin'] },
            resolve: {
              users: EditUserResolve,
            },
          },
          {
            path: 'admin/reports',
            component: ReportsComponent,
            canActivate: [RoleGuard, AuthGuard],
            data: { roles: ['Admin'] },
            resolve: {
              portal: ReportsResolve,
            },
          },
          {
            path: 'admin/users',
            component: UserComponent,
            canActivate: [RoleGuard, AuthGuard],
            data: { roles: ['Admin'] },
            resolve: {
              users: UserResolve,
            },
          },
          {
            path: 'admin/water-bodies/add',
            component: WaterBodiesFormComponent,
            canActivate: [RoleGuard, AuthGuard],
            data: { roles: ['Admin'] },
            resolve: {
              waterBodies: WaterBodiesFormResolve,
            },
          },
          {
            path: 'admin/water-bodies/add-new',
            component: AddWaterBodiesComponent,
            canActivate: [RoleGuard, AuthGuard],
            data: { roles: ['Admin'] },
            resolve: {
              waterBodies: WaterBodiesResolve,
            },
          },
          {
            path: 'admin/water-bodies/edit/:waterBodyId',
            component: AddWaterBodiesComponent,
            canActivate: [RoleGuard, AuthGuard],
            resolve: {
              waterBodies: WaterBodiesResolve,
            },
            data: {
              isEdit: true,
              roles: ['Admin'],
            },
          },
          {
            path: 'admin/water-bodies',
            component: WaterBodiesComponent,
            canActivate: [RoleGuard, AuthGuard],
            data: { roles: ['Admin'] },
            resolve: {
              waterBodies: WaterBodiesResolve,
            },
          },
          {
            path: 'boatyard',
            component: BoatyardComponent,
            resolve: {
              portal: BoatyardResolve,
            },
          },
          {
            path: 'boatyard/vessel/:id',
            component: VesselEditComponent,
            resolve: {
              portal: VesselEditResolve,
            },
          },
          {
            path: 'admin/vessel/:id',
            component: VesselEditComponent,
            canActivate: [RoleGuard, AuthGuard],
            data: { roles: ['Admin'] },
            resolve: {
              portal: VesselEditResolve,
            },
          },
          {
            path: 'select-service',
            component: SelectServiceComponent,
            resolve: {
              portal: SelectServiceResolve,
            },
          },
          {
            path: 'bank-information',
            component: BankInformationComponent,
            canActivate: [AuthGuard],
          },
          {
            path: 'admin/posts',
            component: PostsComponent,
            canActivate: [RoleGuard, AuthGuard],
            data: { roles: ['Admin'] },
          },
          {
            path: 'admin/posts/add',
            component: AddEditPostsComponent,
            canActivate: [RoleGuard, AuthGuard],
            data: { roles: ['Admin'] },
          },
          {
            path: 'admin/posts/edit-post/:id',
            component: AddEditPostsComponent,
            canActivate: [RoleGuard, AuthGuard],
            data: { roles: ['Admin'] },
          },
          {
            // https://www.anchorrides.com/manage/account-deletion/captain-app
            path: 'account-deletion/captain-app',
            component: CaptainDeletionRequestComponent,
            canActivate: [AuthGuard],
          },
        ],
      },
    ]),
  ],
  exports: [RouterModule],
})
export class PortalRoutingModule {}
